export const categories = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '热门电影大全，动作片、爱情片、科幻片等高清在线观看',
    keywords: '电影在线观看,高清电影,免费电影,动作电影,爱情电影',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '最新电视剧全集免费在线播放，国产剧、韩剧、美剧应有尽有',
    keywords: '电视剧在线观看,电视剧全集,免费电视剧,国产剧,韩剧',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目高清在线看，搞笑综艺、音乐综艺、真人秀',
    keywords: '综艺节目在线看,热门综艺,搞笑综艺,真人秀,免费综艺',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '最新动漫番剧免费在线看，日漫、国漫、剧场版一网打尽',
    keywords: '动漫在线观看,最新动漫,日漫,国漫,免费动漫',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '精选纪录片高清在线看，自然、历史、科技纪录片合集',
    keywords: '纪录片在线观看,自然纪录片,历史纪录片,免费纪录片',
  },
  {
    slug: 'duanju',
    name: '短剧',
    icon: 'ri-smartphone-line',
    description: '热门短剧全集免费在线看，爽文短剧、甜宠短剧不间断',
    keywords: '短剧在线观看,免费短剧,热门短剧,爽文短剧,甜宠短剧',
  },
];

export const allVideos = [
  {
    id: 1,
    title: '流浪地球3：星辰大海',
    category: 'dianying',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20futuristic%20spaceship%20and%20stars%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20dark%20space%20background%2C%20epic%20scale%2C%20high%20quality%20film%20poster&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '128分钟',
    rating: 9.2,
    year: 2026,
    description: '人类文明在星际间寻找新家园的史诗级科幻巨制，视觉特效震撼人心。',
    views: '2.3亿',
    tags: ['科幻', '冒险', 'IMAX'],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '长安十二时辰之暗夜追踪',
    category: 'dianying',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%2C%20period%20drama%20film%20poster%2C%20mysterious%20atmosphere%2C%20tang%20dynasty%20style%2C%20warm%20golden%20lighting%2C%20cinematic&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '142分钟',
    rating: 8.9,
    year: 2026,
    description: '盛唐长安暗流涌动，一名独行侠客揭开惊天阴谋的传奇故事。',
    views: '1.8亿',
    tags: ['悬疑', '古装', '动作'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '狂飙：最终章',
    category: 'dianshiju',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20scene%20modern%20Chinese%20city%2C%20intense%20atmosphere%2C%20police%20and%20underworld%2C%20dark%20moody%20lighting%2C%20film%20noir%20style%2C%20dramatic%20tension&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '45分钟/集',
    rating: 9.5,
    year: 2026,
    description: '扫黑除恶专项斗争进入深水区，正邪较量白热化。',
    views: '5.6亿',
    tags: ['犯罪', '悬疑', '国产剧'],
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '繁花似锦年代',
    category: 'dianshiju',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20with%20neon%20lights%2C%20period%20drama%20TV%20series%2C%20nostalgic%20atmosphere%2C%20warm%20vintage%20tones%2C%20river%20bund%20view%2C%20cinematic%20quality&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '42分钟/集',
    rating: 8.7,
    year: 2026,
    description: '九十年代上海滩，一代人的奋斗与梦想交织的都市传奇。',
    views: '3.2亿',
    tags: ['都市', '年代', '情感'],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '极限挑战第十季',
    category: 'zongyi',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20with%20celebrities%20having%20fun%20challenges%2C%20colorful%20vibrant%20scene%2C%20bright%20sunlight%2C%20energetic%20atmosphere%2C%20entertainment%20TV%20show&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '90分钟/期',
    rating: 8.5,
    year: 2026,
    description: '国民综艺重磅回归，全新阵容带来爆笑极限挑战。',
    views: '4.1亿',
    tags: ['真人秀', '搞笑', '挑战'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '歌手·巅峰对决',
    category: 'zongyi',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20stage%20with%20dramatic%20spotlights%2C%20singing%20performance%2C%20grand%20studio%20setting%2C%20emotional%20atmosphere%2C%20professional%20lighting%2C%20concert%20feel&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '120分钟/期',
    rating: 9.0,
    year: 2026,
    description: '顶级歌手同台竞技，天籁之音震撼全场。',
    views: '6.8亿',
    tags: ['音乐', '竞技', 'Live'],
    isHot: true,
    isNew: true,
  },
  {
    id: 7,
    title: '鬼灭之刃：无限城篇',
    category: 'dongman',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20dark%20fantasy%20castle%20interior%2C%20demon%20slayer%20aesthetic%2C%20dramatic%20action%20scene%2C%20vibrant%20color%20contrast%2C%20detailed%20background%20art%2C%20epic%20scale&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '88分钟',
    rating: 9.6,
    year: 2026,
    description: '鬼杀队最终决战，无限城内殊死搏斗的终极篇章。',
    views: '4.9亿',
    tags: ['热血', '战斗', '剧场版'],
    isHot: true,
    isNew: true,
  },
  {
    id: 8,
    title: '进击的巨人完结篇',
    category: 'dongman',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20giant%20titans%20and%20soldiers%2C%20dramatic%20sky%2C%20dark%20fantasy%20aesthetic%2C%20high%20quality%20animation%20art%2C%20intense%20action&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '75分钟',
    rating: 9.4,
    year: 2025,
    description: '人类与巨人的最终对决落幕，震撼世界的史诗完结。',
    views: '7.2亿',
    tags: ['热血', '奇幻', '完结'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '地球脉动III',
    category: 'jilupian',
    categoryName: '纪录片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wildlife%20animals%20in%20savanna%2C%20golden%20sunset%20light%2C%20breathtaking%20landscape%2C%20BBC%20style%20cinematography%2C%20ultra%20HD%20quality&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '50分钟/集',
    rating: 9.8,
    year: 2026,
    description: 'BBC史诗级自然纪录片续作，探索地球最隐秘的角落。',
    views: '1.5亿',
    tags: ['自然', 'BBC', '4K'],
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '故宫100：隐秘的宫殿',
    category: 'jilupian',
    categoryName: '纪录片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Forbidden%20City%20imperial%20palace%20architecture%20in%20Beijing%2C%20historical%20documentary%20style%2C%20golden%20roof%20details%2C%20ancient%20Chinese%20architecture%2C%20warm%20sunset%20lighting%2C%20grand%20scale&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '30分钟/集',
    rating: 9.3,
    year: 2025,
    description: '深入故宫未开放区域，揭开六百年皇家秘史。',
    views: '0.9亿',
    tags: ['历史', '文化', '故宫'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '重生之豪门千金',
    category: 'duanju',
    categoryName: '短剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20mansion%20interior%20with%20elegant%20woman%2C%20Chinese%20short%20drama%20style%2C%20wealthy%20lifestyle%20aesthetic%2C%20dramatic%20lighting%2C%20fashionable%20setting%2C%20glamorous%20atmosphere&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '3分钟/集',
    rating: 8.2,
    year: 2026,
    description: '重生归来的豪门千金，逆天改命惊艳所有人的爽文短剧。',
    views: '8.3亿',
    tags: ['爽文', '甜宠', '逆袭'],
    isHot: true,
    isNew: true,
  },
  {
    id: 12,
    title: '霸道总裁爱上我',
    category: 'duanju',
    categoryName: '短剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20office%20scene%20with%20handsome%20CEO%20and%20young%20woman%2C%20Chinese%20web%20drama%20style%2C%20modern%20skyscraper%20background%2C%20soft%20romantic%20lighting%2C%20fashionable%20aesthetic&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '2分钟/集',
    rating: 7.9,
    year: 2026,
    description: '普通女孩与冷面总裁的甜蜜邂逅，全网播放破十亿。',
    views: '12.5亿',
    tags: ['甜宠', '都市', '短剧'],
    isHot: true,
    isNew: false,
  },
  {
    id: 13,
    title: '哪吒之魔童降世2',
    category: 'dianying',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20style%20mythological%20character%20with%20fire%20and%20wind%20effects%2C%20epic%20fantasy%20battle%2C%20vibrant%20red%20and%20gold%20colors%2C%20cinematic%20lighting%2C%20dramatic%20composition&width=640&height=360&seq=video-thumb-13&orientation=landscape',
    duration: '118分钟',
    rating: 9.1,
    year: 2026,
    description: '国漫之光续作，哪吒再战命运的热血传奇。',
    views: '15.8亿',
    tags: ['动画', '神话', '国漫'],
    isHot: true,
    isNew: true,
  },
  {
    id: 14,
    title: '白夜追凶2',
    category: 'dianshiju',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20crime%20investigation%20scene%20at%20night%2C%20rainy%20street%20with%20police%20car%20lights%2C%20thriller%20TV%20series%20aesthetic%2C%20noir%20atmosphere%2C%20urban%20Chinese%20city%2C%20suspenseful%20mood&width=640&height=360&seq=video-thumb-14&orientation=landscape',
    duration: '43分钟/集',
    rating: 9.3,
    year: 2026,
    description: '经典悬疑IP回归，双胞胎兄弟联手破获连环奇案。',
    views: '4.5亿',
    tags: ['悬疑', '犯罪', '推理'],
    isHot: true,
    isNew: true,
  },
  {
    id: 15,
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20running%20variety%20show%20in%20beautiful%20nature%20landscape%2C%20celebrities%20playing%20games%2C%20sunny%20green%20environment%2C%20energetic%20and%20fun%20atmosphere%2C%20colorful%20costumes&width=640&height=360&seq=video-thumb-15&orientation=landscape',
    duration: '85分钟/期',
    rating: 8.0,
    year: 2026,
    description: '跑男家族全新生态之旅，绿水青山间的欢乐奔跑。',
    views: '3.7亿',
    tags: ['户外', '搞笑', '环保'],
    isHot: false,
    isNew: true,
  },
  {
    id: 16,
    title: '深海迷航',
    category: 'jilupian',
    categoryName: '纪录片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20with%20bioluminescent%20creatures%2C%20underwater%20documentary%20style%2C%20mysterious%20deep%20sea%20atmosphere%2C%20rare%20marine%20life%2C%20dark%20blue%20water%2C%20scientific%20exploration&width=640&height=360&seq=video-thumb-16&orientation=landscape',
    duration: '48分钟/集',
    rating: 9.5,
    year: 2026,
    description: '潜入万米深海，探索人类从未见过的神秘生物世界。',
    views: '1.1亿',
    tags: ['海洋', '探索', '4K'],
    isHot: false,
    isNew: true,
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得期待的十部国产大片，每一部都是视觉盛宴',
    category: 'dianying',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20movie%20posters%20collage%20with%20dramatic%20lighting%2C%20film%20reel%20aesthetic%2C%20red%20carpet%20premiere%20style%2C%20cinematic%20atmosphere%2C%20golden%20spotlights&width=800&height=450&seq=article-01&orientation=landscape',
    summary: '2026年国产电影市场迎来爆发期，从科幻巨制到现实主义题材，各路大片蓄势待发。',
    content: `2026年，中国电影市场迎来了前所未有的繁荣景象。从春节档到暑期档，国产大片轮番上阵，为观众带来了一场又一场的视觉盛宴。

   首先，科幻题材继续领跑。《流浪地球3》以更加宏大的宇宙叙事和精良的视觉特效，将中国科幻电影推向了新的高度。影片中人类文明在星际间寻找新家园的故事，不仅震撼了观众的眼球，更触动了每个人的心灵。

   动画电影同样不甘示弱。《哪吒之魔童降世2》延续了前作的热血与感动，以更加成熟的叙事和惊艳的画面表现，再次证明了国漫的无限可能。

   现实主义题材方面，《长安十二时辰之暗夜追踪》以盛唐为背景，融合悬疑与动作元素，展现了国产类型片的新突破。

   业内人士分析，2026年国产电影票房有望突破800亿元大关，中国正在成为全球最重要的电影市场之一。`,
    author: '影视观察员',
    date: '2026-07-28',
    views: '128万',
    tags: ['国产电影', '票房', '2026'],
  },
  {
    id: 2,
    title: '短剧市场爆发式增长：为什么大家都爱看短剧？',
    category: 'duanju',
    categoryName: '短剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20vertical%20short%20video%20content%2C%20modern%20lifestyle%2C%20young%20person%20watching%20phone%2C%20cozy%20home%20environment%2C%20digital%20entertainment%2C%20warm%20lighting&width=800&height=450&seq=article-02&orientation=landscape',
    summary: '短剧行业在2026年迎来爆发，单部作品播放量动辄破亿，这背后反映了怎样的消费趋势？',
    content: `如果说2025年是短剧的"元年"，那么2026年就是短剧的"爆发年"。据行业数据显示，2026年上半年短剧市场规模已突破500亿元，同比增长超过200%。

   短剧为何如此火爆？首先，碎片化消费习惯的养成是关键。在快节奏的现代生活中，单集1-3分钟的短剧完美契合了用户的碎片时间。地铁上、午休时、睡前，随时随地都能刷上几集。

   其次，内容精准击中用户爽点。无论是"霸道总裁"、"重生逆袭"还是"豪门恩怨"，短剧用最直接的方式满足了观众的情感需求。不需要复杂的铺垫，直接进入高潮，让观众欲罢不能。

   从制作端来看，短剧的制作成本远低于传统影视剧，一部爆款短剧的投资回报率可达数十倍。这也吸引了大量资本和人才涌入这一赛道。

   数据显示，《重生之豪门千金》累计播放量突破8.3亿，《霸道总裁爱上我》更是达到了12.5亿的惊人成绩。短剧，正在重新定义内容消费的方式。`,
    author: '行业分析师',
    date: '2026-07-25',
    views: '96万',
    tags: ['短剧', '行业分析', '内容消费'],
  },
  {
    id: 3,
    title: '国产悬疑剧崛起：《狂飙》《白夜追凶2》领跑口碑榜',
    category: 'dianshiju',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Suspenseful%20crime%20drama%20scene%20with%20detective%20investigating%2C%20dark%20moody%20atmosphere%2C%20Chinese%20TV%20series%20aesthetic%2C%20urban%20night%20setting%2C%20film%20noir%20style%2C%20intense%20expression&width=800&height=450&seq=article-03&orientation=landscape',
    summary: '国产悬疑剧正在经历黄金时代，高品质剧集层出不穷，赢得了观众的一致好评。',
    content: `近年来，国产悬疑剧质量突飞猛进，已经成为中国电视剧市场最受欢迎的题材类型之一。

   《狂飙：最终章》以9.5分的超高评分，成为2026年开年最受瞩目的剧集。该剧延续了前作的硬核风格，在扫黑除恶的大背景下，深入探讨了人性的复杂与社会的多面性。张颂文、张译等实力派演员的精湛演技，让每一个角色都立体饱满。

   《白夜追凶2》时隔多年回归，依然保持了前作的高水准。潘粤明一人分饰两角的表演再次惊艳观众，而更加复杂的案件设计和精妙的推理过程，让这部剧成为悬疑迷必追的作品。

   国产悬疑剧的成功，得益于剧本质量的整体提升和制作水平的飞跃。编剧们不再满足于简单的案件侦破，而是通过悬疑的外壳，探讨更加深刻的社会议题和人性命题。

   从《隐秘的角落》到《狂飙》，再到《白夜追凶2》，国产悬疑剧已经形成了自己独特的审美风格和叙事语言，在国际市场上也开始崭露头角。`,
    author: '剧评人',
    date: '2026-07-20',
    views: '215万',
    tags: ['悬疑剧', '国产剧', '口碑'],
  },
  {
    id: 4,
    title: '动漫迷必看：2026年最热门日漫与国漫推荐',
    category: 'dongman',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20characters%20collage%20with%20action%20poses%2C%20Japanese%20and%20Chinese%20animation%20style%20mix%2C%20vibrant%20energy%2C%20dynamic%20composition%2C%20manga%20aesthetic%2C%20bright%20colors&width=800&height=450&seq=article-04&orientation=landscape',
    summary: '从热血战斗到治愈日常，2026年的动漫世界精彩纷呈。',
    content: `2026年的动漫市场可谓百花齐放，无论是日本动漫还是国产动漫，都涌现出了大量优秀作品。

   日漫方面，《鬼灭之刃：无限城篇》无疑是年度最受期待的剧场版。这部作品以88分钟的片长，完美呈现了漫画中最精彩的篇章。飞碟社的精湛制作让每一帧画面都堪称艺术品，而剧情的情感张力更是让无数观众在影院落泪。

   国漫方面，《哪吒之魔童降世2》以118分钟的篇幅，讲述了一个更加宏大的神话故事。饺子导演在保持前作风格的基础上，加入了更多对宿命与选择的思考，让这部动画不只是视觉盛宴，更是一场心灵之旅。

   此外，一些中小成本动漫作品也值得关注。国漫《深海》《大雨》以独特的艺术风格和深沉的情感表达，展现了中国动画的多元可能性。日漫《葬送的芙莉莲》《迷宫饭》则以细腻的叙事和温暖的基调，治愈了无数观众。

   动漫不再只是"给小孩看的东西"，它已经成为一种跨越年龄的文化现象。`,
    author: '动漫编辑',
    date: '2026-07-15',
    views: '187万',
    tags: ['动漫', '日漫', '国漫', '推荐'],
  },
  {
    id: 5,
    title: '宅家观影指南：如何打造家庭影院级观影体验',
    category: 'dianying',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20large%20TV%20screen%2C%20comfortable%20sofa%2C%20dim%20warm%20lighting%2C%20speakers%2C%20modern%20living%20room%2C%20cinematic%20atmosphere%2C%20premium%20interior&width=800&height=450&seq=article-05&orientation=landscape',
    summary: '不用去电影院，在家也能享受沉浸式观影体验。从设备到环境，一篇搞定。',
    content: `随着流媒体平台内容的日益丰富，越来越多的人选择在家观影。但如何在家中获得接近影院的观影体验呢？这里有一份详细的宅家观影指南。

   第一步：选择合适的显示设备。如果预算充足，推荐75英寸以上的OLED电视，其完美的黑色表现和广色域能够呈现电影原有的质感。或者选择4K激光投影仪，搭配120英寸以上的幕布，获得真正的"大银幕"体验。

   第二步：音响系统不可忽视。一套5.1声道或7.1声道的环绕音响系统，能够让你感受到电影中每一个细微的声音变化。如果空间有限，高品质的回音壁也是不错的选择。

   第三步：环境光控制。拉上遮光窗帘，关掉所有直射光源，只保留一些柔和的氛围灯。这样既能保护眼睛，又能营造影院的沉浸感。

   第四步：选择好的片源。在69视频平台，你可以找到海量的高清电影和电视剧资源，从4K蓝光画质到无损音轨，满足发烧友的极致追求。

   最后，别忘了准备一些零食和饮料。爆米花、可乐、薯片……让观影体验更加完美！`,
    author: '数码达人',
    date: '2026-07-10',
    views: '76万',
    tags: ['观影指南', '家庭影院', '数码'],
  },
  {
    id: 6,
    title: '综艺节目进化论：从娱乐到文化的华丽转身',
    category: 'zongyi',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20production%20studio%20with%20colorful%20stage%20lighting%2C%20cameras%20and%20equipment%2C%20behind%20the%20scenes%20atmosphere%2C%20professional%20crew%2C%20creative%20energy%2C%20entertainment%20industry&width=800&height=450&seq=article-06&orientation=landscape',
    summary: '中国综艺节目正在经历一场深刻的变革，从单纯的娱乐消遣，升级为文化传播的新载体。',
    content: `回顾中国综艺节目的发展历程，从早期的《快乐大本营》到如今的《歌手》《极限挑战》，综艺节目的内容和形式都发生了翻天覆地的变化。

   2026年的综艺市场呈现出几个明显趋势。首先是文化类综艺的崛起。《国家宝藏》《典籍里的中国》等现象级文化节目，将厚重的历史文化以轻松有趣的方式呈现给观众，实现了娱乐与教育的完美结合。

   其次是音乐综艺的持续进化。《歌手·巅峰对决》以9.0的高分证明了优质音乐节目的市场号召力。节目不再只是简单的歌唱比赛，而是升级为一场场精心打造的音乐盛宴。

   第三是真人秀节目的多元化。《极限挑战第十季》在保持搞笑风格的同时，加入了更多社会关怀和人文思考；《奔跑吧·生态篇》则将镜头对准绿水青山，传递环保理念。

   综艺节目正在摆脱"肤浅娱乐"的标签，成为传播正能量、弘扬优秀文化的重要平台。`,
    author: '综艺评论员',
    date: '2026-07-05',
    views: '143万',
    tags: ['综艺', '文化', '趋势'],
  },
];